declare const __CLIENT_TENANT__: string;
declare const __CLIENT_ID__: string;

if (!__CLIENT_TENANT__) {
  throw new Error('__CLIENT_TENANT__ is not set!');
}

if (!__CLIENT_ID__) {
  throw new Error('__CLIENT_ID__ is not set!');
}

var cacheLocation = 'localStorage';


export default {
  instance: 'https://login.microsoftonline.com/',
  tenant: __CLIENT_TENANT__,
  clientId: __CLIENT_ID__,
  postLogoutRedirectUri: window.location.origin,
  cacheLocation,
  redirectUri: window.location.origin + '/aad-callback',
};

export const scopes = {
  scopes: [__CLIENT_ID__ + '/User.Access']
};
